import JourneyMapModal from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { getItemMapOpened } from 'redux/modules/journey-map/selectors';
import { closeJourneyMapModal } from 'redux/modules/journey-map/effects';

const enhance = compose(
  connect(
    (state) => ({
      isOpened: getItemMapOpened(state),
    }),
    {
      onClose: closeJourneyMapModal,
    }
  )
);

export default enhance(JourneyMapModal);
